import { ThemeFamilies } from './types';
var getToggle = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.primary,
            light: colors.white,
            dark: colors.surface2,
            disabled: colors.surface4,
            disabledText: colors.surface3,
        },
        _a[ThemeFamilies.SECONDARY] = {
            main: colors.branding.secondary,
            light: colors.white,
            dark: colors.surface2,
            disabled: colors.surface4,
            disabledText: colors.surface3,
        },
        _a);
};
export default getToggle;
